import { getPartnerAuthSlogan } from '~/components/utils/helpers/partner';
import { toAbsoluteUrl } from '~/vendor/_metronic/_helpers';

export const config = {
  title: 'Sign in to',
  description: getPartnerAuthSlogan(),
  loginVisual: toAbsoluteUrl("/media/svg/illustrations/login-visual-6.svg"),
};
